import { throwError } from 'rxjs';

import { ToastService } from '../components/ui';

export function handleError(error: any) {
  const message = error?.error?.message || error?.message || 'Something went wrong';
  console.error('Error:', message);
  return throwError(() => error);
}

export function handleErrorWithToast(error: any, toastService: ToastService) {
  const message = error?.error?.message || error?.message || 'Something went wrong';
  console.error('Error:', message);
  toastService.error(message);
  return throwError(() => error);
}
